var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOperationalForecastNetwork = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M16 25.333a9.333 9.333 0 1 0 0-18.666 9.333 9.333 0 0 0 0 18.666m0 1.334C10.109 26.667 5.333 21.89 5.333 16S10.11 5.333 16 5.333 26.667 10.11 26.667 16 21.89 26.667 16 26.667"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M16 25.333c2.508 0 4.889-4.081 4.889-9.333s-2.381-9.333-4.89-9.333c-2.507 0-4.888 4.081-4.888 9.333s2.38 9.333 4.889 9.333m0 1.334c-3.437 0-6.222-4.776-6.222-10.667S12.563 5.333 16 5.333c3.436 0 6.222 4.776 6.222 10.667S19.436 26.667 16 26.667"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M16.667 6.222v4.445h8.222V12h-8.222v3.333h9.11v1.334h-9.11V20h8.222v1.333h-8.222v4.445h-1.334v-4.445H7.111V20h8.222v-3.333h-9.11v-1.334h9.11V12L7.111 12v-1.333l8.222-.001V6.222z",
  clipRule: "evenodd"
})));
export default SvgOperationalForecastNetwork;